// make reducers
import entities from './entities';
import user from './user';
import ui from './ui';
import relationships from './relationships';
import notifications from './notifications';
import uuidMappings from './urlMappings';
import auth from './auth';
import { combineReducers } from 'redux';
import appConfig from './appConfig';
import orgSummaryPreferences from './summaryViewPreferences';
import { paginationApi } from '../middlewares/paginationApi';
import { defaultApi } from '@/middlewares/defaultApi';

const rootReducer = combineReducers({
    entities,
    relationships,
    user,
    ui,
    notifications,
    uuidMappings,
    auth,
    appConfig,
    orgSummaryPreferences,
    [defaultApi.reducerPath]: defaultApi.reducer,
    [paginationApi.reducerPath]: paginationApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
